import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MySubscriptions from "../../components/dashboard/dashboardPartials/MySubscriptions";
import MyOrders from "../../components/dashboard/dashboardPartials/MyOrders";
import AllProfileOptions from "../../components/dashboard/profilePartials/AllProfileOptions";
import { useGeneral } from "../../components/contexts/GeneralContext";

const ProfileManagementPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper component={<AllProfileOptions />} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ProfileManagementPage;
